<div class="entity-relation-change-transaction-details">

    @if(isReadonly) {

    <div class="entity-relation-change-transaction-label">Senast ändrad</div>
    <div class="entity-relation-change-transaction-info">
        {{ lastModified ? lastModified : '-' }}
    </div>

    }
    @else {

    <div class="entity-relation-change-transaction-label">Senast ändrad av</div>
    <div class="entity-relation-change-transaction-info">
        @if(!entityRelationChangeTransactionDetails && !lastModified) {
        Inga ändringar har gjorts
        }

        @if(entityRelationChangeTransactionDetails) {

        {{ entityRelationChangeTransactionDetails.changedByFullName }}
        {{ entityRelationChangeTransactionDetails.changedAt }}

        }
        @else {

        @if(lastModified) {
        Okänd användare
        {{ lastModified }}
        }

        }
    </div>

    }

</div>